import { Container } from '@almbrand/container';
import { Grid, GridCell } from '@almbrand/grid';
import { ModalComponent, ProductCalculatorSelectorTemplate, QuickBasket } from 'components';
import { HeaderComponent } from 'components/4-habitats';
import { ThemeNames } from 'constantsValues';
import { PageContext } from 'context/PageContext';
import { useModal } from 'hooks';
import { memo, useContext, useState } from 'react';
import { useAppSelector } from 'store/index';
import styles from './ProductCalculatorSelectorPage.module.scss';

export const ProductCalculatorSelectorPage: React.FC<PageModel> = memo(() => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext ?? {};
	const themeName = ThemeNames[theme];
	const { headerContent, pageModel } = pageContext ?? {};
	const [modalCssStyle, setModalCssStyle] = useState<React.CSSProperties>();
	const { displayModal } = useModal();
	const { displayModal: showModal } = useAppSelector((state) => state.modal);

	return (
		<>
			<div
				data-page-type='ProductCalculatorSelectorPage'
				className={styles.ProductCalculatorSelectorPage__HeaderComponent}
			>
				<Container
					desktopWidth='1600'
					tabletWidth='1280'
					mobileWidth='744'
				>
					<Grid>
						<GridCell>
							<HeaderComponent
								{...headerContent}
								loginLabelText='BASKET'
								onBasketClick={() => {
									const style = displayModal({
										title: 'Din foreløbige kurv',
										content: <QuickBasket themeName={themeName} />,
										subtitle: '',
										padding: { left: 0, right: 0 },
										cssStyle: {
											'--modal-background': 'var(--color-secondary-6)',
											'--modal-close-button-background': 'var(--color-primary-4)',
										} as React.CSSProperties,
									});
									setModalCssStyle(style);
								}}
							/>
						</GridCell>
					</Grid>
				</Container>
			</div>
			<Container
				desktopWidth={'1600'}
				tabletWidth='fullWidth'
				mobileWidth={'360'}
				noPadding
			>
				<ProductCalculatorSelectorTemplate pageModel={pageModel as ProductCalculatorSelectorTemplateModel} />
			</Container>
			{showModal && <ModalComponent cssStyle={modalCssStyle} />}
		</>
	);
});

ProductCalculatorSelectorPage.displayName = 'ProductCalculatorSelectorPage';
